import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { FetchError } from '@amzn/handshake-painter-typescript-client/v1';
import { useAnalyticsContext } from 'src/common/metrics';
import { ParzivalGatewayAuthErrorType } from 'src/utils/auth';
import { InvalidAuthPage } from './InvalidAuthPage';
import { MissingAuthPage } from './MissingAuthPage';
import { DogPage } from './DogPage';
import { isBotTraffic } from './rumFilters';
// Renders the appropriate error page based on the error type
export const AppError = ({ error }) => {
    const rumClient = useAnalyticsContext();
    /**
     * We record the DogPage RUM event inside the DogPage component since it's called
     * from different parts of the app. If an error component is only called from here,
     * then use this useEffect to trigger the rum event.
     */
    useEffect(() => {
        if (error instanceof FetchError && !isBotTraffic()) {
            const parzivalError = error.cause;
            rumClient.recordEvent('PARZIVAL_AUTH_ERROR_PAGE', {
                errorType: parzivalError.errorType,
                errorMessage: parzivalError.originalMessage,
            });
        }
    }, [rumClient, error]);
    // Handle Parzival error cases
    if (error instanceof FetchError) {
        const parzivalError = error.cause;
        if (parzivalError.errorType === ParzivalGatewayAuthErrorType.MISSING_AUTH) {
            return _jsx(MissingAuthPage, {});
        }
        else if (parzivalError.errorType === ParzivalGatewayAuthErrorType.EXPIRED_AUTH ||
            parzivalError.errorType === ParzivalGatewayAuthErrorType.INCORRECT_AUTH) {
            return _jsx(InvalidAuthPage, { errorType: parzivalError.errorType });
        }
    }
    return _jsx(DogPage, {});
};
